module.exports = __webpack_public_path__ + "static/media/camera.c4de9582.png";